import React from 'react';

const ArticleFooter = ({ brand, page }) => {
	return (
		<div className='ArticleFooter'>
			<span className='ArticleFooter__brand'>{brand}</span>
			<span className='ArticleFooter__site'>
				tablegroup.com
				{!!page && <span className='ArticleFooter__page'>{page}</span>}
			</span>
		</div>
	);
};

export default ArticleFooter;
